import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import i18n from 'i18next';

import { gameRunningStatuses } from 'config/gameRunningStatuses';
import DialogSystem from 'client/components/DialogSystem';

const DialogInfoAfterLoginTrigger = forwardRef((_, ref) => {
    const {
        gameRunningStatus,
        periodPlayMatchedInfo: { matchedInfo: { match: isInPlayTimePeriod } = {} } = {}
    } = useSelector(s => s.promoState);
    const [open, setOpen] = useState(false);
    let hasInfo = false;

    useImperativeHandle(ref, () => ({
        checkIsHasInfo: shouldOpen => {
            if (shouldOpen && hasInfo) {
                setOpen(true);
            }
            return hasInfo;
        }
    }));

    function onClose() {
        setOpen(false);
    }

    if (gameRunningStatus === gameRunningStatuses.SUSPEND) {
        hasInfo = true;
        const title = i18n.t('label.system.unavailable');
        const body = i18n.t('label.try_again_later');
        return <DialogSystem title={title} body={body} closePopup={onClose} isOpen={open} />;
    } else if (gameRunningStatus === gameRunningStatuses.END) {
        hasInfo = true;
        const title = i18n.t('label.promo_is_end');
        const body = i18n.t('label.see_you_next_time');
        return <DialogSystem title={title} body={body} closePopup={onClose} isOpen={open} />;
    } else if (!isInPlayTimePeriod) {
        hasInfo = true;
        const title = i18n.t('label.system.unavailable');
        const body = i18n.t('label.not_in_play_period');
        return <DialogSystem title={title} body={body} closePopup={onClose} isOpen={open} />;
    }

    return null;
});

DialogInfoAfterLoginTrigger.displayName = 'DialogInfoAfterLoginTrigger';

export default DialogInfoAfterLoginTrigger;
